import PropTypes from 'prop-types';
import React from 'react';
import {compose} from 'redux';
import {Segment} from 'semantic-ui-react';
import {get as _get} from 'lodash';

import {graphql} from 'react-apollo';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import {convertToInt, isUrlParamValid} from '@utils/helpers';
import {renderModalError} from '@utils/forms';
import {showModal} from '@utils/modal';
import {routes} from '@constants/routes';
import {GetEventWatermarkingListing} from '@graphql/eventContentWatermarking/query';

import EventWatermarkingButtons from '../components/EventWatermarking/EventWatermarkingButtons';
import EventWatermarkingMissingConfigBanner from '../components/EventWatermarking/EventWatermarkingMissingConfigBanner';
import EventWatermarkingModalRouting from '../components/EventWatermarking/EventWatermarkingModalRouting';
import EventWatermarkingTable from '../components/EventWatermarking/EventWatermarkingTable';

export class EventsWatermarkingIndex extends React.Component {
    static propTypes = {
        DataEventWatermarking: PropTypes.shape({
            eventContentWatermarking: PropTypes.shape({
                watermarkings: PropTypes.arrayOf(PropTypes.object),
                missing_watermarking_configs: PropTypes.arrayOf(PropTypes.string),
            }),
            loading: PropTypes.bool,
        }),
        eventId: PropTypes.number,
    };

    static defaultProps = {
        DataEventWatermarking: {
            eventContentWatermarking: {
                watermarkings: [],
                missing_watermarking_configs: [],
            },
            loading: true,
        },
    };

    componentDidMount() {
        if (!isUrlParamValid(this.props.eventId)) {
            return showModal({
                isVisible: true,
                content: renderModalError('Event', routes.events.index.path),
            });
        }
    }

    render() {
        const loading = _get(this.props, 'DataEventWatermarking.loading', true),
            watermarkings = _get(this.props, 'DataEventWatermarking.eventContentWatermarking.watermarkings', []),
            missingConfigLabels = _get(
                this.props, 'DataEventWatermarking.eventContentWatermarking.missing_watermarking_configs', []
            ),
            eventId = convertToInt(this.props.eventId);


        return (
            <div>
                <HeaderRenderer
                    buttons={EventWatermarkingButtons}
                    buttonsProps={{eventId}}
                    loading={loading}
                    messagesBoxNames={'eventWatermarkingMessage'}
                />
                <EventWatermarkingMissingConfigBanner missingConfigLabels={missingConfigLabels}/>
                <Segment basic className='--table'>
                    <EventWatermarkingTable
                        eventContentWatermarkings={watermarkings}
                        eventId={eventId}
                        loading={loading}
                    />
                </Segment>
            </div>
        );
    }
}

const EventsWatermarkingIndexWithGraphQL = compose(
    graphql(GetEventWatermarkingListing, {
        options: (props) => ({
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
            variables: {
                event: convertToInt(props.eventId),
            },
        }),
        name: 'DataEventWatermarking',
    })
)(EventsWatermarkingIndex);

const EventsWatermarkingIndexWithModalRouting = (props) => (
    <>
        <EventsWatermarkingIndexWithGraphQL {...props} />
        <EventWatermarkingModalRouting />
    </>
);

EventsWatermarkingIndexWithModalRouting.displayName = 'EventsWatermarkingIndexWithModalRouting';

export default EventsWatermarkingIndexWithModalRouting;
